import { render, staticRenderFns } from "./join-success.vue?vue&type=template&id=71db42af&scoped=true";
import script from "./join-success.vue?vue&type=script&lang=js";
export * from "./join-success.vue?vue&type=script&lang=js";
import style0 from "./join-success.vue?vue&type=style&index=0&id=71db42af&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "71db42af", null);
export default component.exports;